export const extractInnerHtmlText = (textData) => {
    var span = document.createElement('span');
    span.innerHTML = textData; 
    return span.textContent || span.innerText;
  };
